import React, { useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Button} from '@mui/material';
import { ContextData } from '../../../context/Context';
import baseUrl from '../../../BaseURL';
import MemberDataPage from '../Contents/Member/MemberDataPage';
import '../Contents/IDCard/CardStudio.css';
import IDCardShow from '../Contents/prentableDisc/IDCardShow';
import { toast } from 'react-toastify';
import { es } from 'faker/lib/locales';
import { useNavigate } from 'react-router-dom';
/* import EditStudentPop from './PopDialogue/Student/EditStudentPop';
 */

const PrentableDisc = () => {




  const [CountData,setCountData] = useState(null)
  const [Token,setToken] = useState(null)
  const {setLoader,accesstoken,RefreshUesFF,Person,Refresh,setRefresh,MemberDataIDCard,setMemberDataIDCard,firstSlot,setfirstSlot,secondSlot,setsecondSlot,setProfileData,setProfileData2} = useContext(ContextData)
  const Navigate = useNavigate()

  useEffect(()=>{setRefresh(!Refresh)},[])

    useEffect(() =>{


      async function FetchData(){
        //  setLoader(true)

      try {
        const response = await axios.get(`${baseUrl}/auth/get_data_member_user/${Person.acc_level}`,{
          withCredentials: true,
          headers: {
            'Accept' : 'application/json',
            'authorization': `Bearer ${accesstoken !== null && accesstoken}`
          }})


        setMemberDataIDCard(response.data)

        setCountData(response.data.length)
        setLoader(false)

      } catch (err) {
         if(err) console.log(err.message)
        // setLoader(false)
      }


}FetchData()





    },[Refresh])

    const filteredMembers = useMemo(() => {
      return MemberDataIDCard ? MemberDataIDCard.filter(list => list.acc_status === 3 && list.id_card_status === "0") : [];
    }, [MemberDataIDCard,Refresh]);

    const count = filteredMembers.length;

    const GetTokens = (token)=>{

      setToken(token)
     // alert(token)
     // console.log(Token)

    }

    const DoneAll = async ()=>{

         //

          const data = {
            tokens : MemberDataIDCard.filter(list => list.acc_status === 3 && list.id_card_status === "0" ||  list.id_card_status === "finished").map(i=>i.r_ID)
          }


           try {
      const res = await axios.put(`${baseUrl}/auth/done_all_cards`, {...data}, {
        withCredentials: true,
        headers: {
          'Accept': 'application/json',
          'authorization': `Bearer ${accesstoken || ""}`
        }
      });

      toast.success(res.data.statusText);
      setRefresh(!Refresh);

    } catch (err) {
      toast.warn(err.message);
    }


    }

    const OnSelectFordDisc = (token) => {


    // Improved selection logic for firstSlot and secondSlot
    if (firstSlot === "" && secondSlot !== token) {

      setfirstSlot(token);
      toast.success("First Slot Selected");

    } else if (secondSlot === "" && firstSlot !== token) {

      setsecondSlot(token);
      toast.success("Second Slot Selected");

    } else if (firstSlot === token) {

      setfirstSlot("");
      setProfileData(null)

      toast.info("First Slot De-selected");

    } else if (secondSlot === token) {

      setsecondSlot("");
      setProfileData2(null)
      toast.info("Second Slot De-selected");

    } else {
      toast.warn("Both slots are already filled. De-select one to select another.");
    }






    }



    const OpenPrintableDisc = () => {

      if(firstSlot === "" || secondSlot === ""){
        toast.error("Please select two members to proceed")
        return
      }
      window.open(`/prentable-page/${firstSlot}/${secondSlot}`, '_blank')






    }


  return (
    <div className="fin-id-workspace fin-print-workspace"><div className="fin-id-layout">
      <aside className="fin-id-member-list hide-at-prnt" aria-label="Members available for printing">
        <div className="fin-id-list-heading"><h2>Print queue</h2><p>Select two members for your print sheet.</p></div>
        {MemberDataIDCard === null ? <p className="fin-card-help">Loading members…</p> : <ul>{MemberDataIDCard.filter(list => list.acc_status === 3 && list.id_card_status === "0" || list.id_card_status === "finished").map((list,index) => <li key={list.token} className={`fin-id-member-row ${firstSlot === list.token || secondSlot === list.token ? 'is-selected' : ''}`}><button onClick={() => GetTokens(list.token)} aria-pressed={Token === list.token}><span aria-hidden="true">{String(index + 1).padStart(2,'0')}</span><span><strong>{list.fname} {list.lname}</strong><small>{list.stateoforigin || 'Member'} · {list.id_card_status === 'finished' ? 'Finished' : 'In preparation'}</small></span></button><div className="fin-id-slot-button"><span>{firstSlot === list.token ? 'Slot 1 selected' : secondSlot === list.token ? 'Slot 2 selected' : 'Available for selection'}</span><Button onClick={() => OnSelectFordDisc(list.token)} variant="outlined">{firstSlot === list.token || secondSlot === list.token ? 'Deselect' : 'Select'}</Button></div></li>)}</ul>}
      </aside>
      <div className="fin-id-main">
        <header className="fin-id-page-heading hide-at-prnt"><div><h2>Print preparation</h2><p>{count} cards awaiting preparation. Review both selected members before opening the print sheet.</p></div><div className="fin-id-page-actions"><Button onClick={DoneAll} variant="outlined" title="Run the existing completion action for finished cards">Done all</Button><Button onClick={OpenPrintableDisc} variant="contained">Open print sheet</Button></div></header>
        <ol className="fin-id-steps hide-at-prnt"><li><span>1</span>Select two members</li><li><span>2</span>Review & save details</li><li><span>3</span>Open print sheet</li></ol>
        <div className="fin-id-studios"><IDCardShow token={Token !== null && Token} /></div>
      </div>
    </div></div>
  );
};
export default PrentableDisc;
